import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request";

interface UseGenerateLabelParams {
	onSuccess?: (returnRequest: ReturnRequestDto) => void;
	onError?: (error: Error) => void;
}

export default function useGenerateLabel(params: UseGenerateLabelParams) {
	const invalidateReturnRequest = useInvalidateReturnRequest();

	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/generate-label",
		{
			onSuccess: (returnRequest: ReturnRequestDto) => {
				invalidateReturnRequest({
					returnRequestId: returnRequest.id,
					shopId: returnRequest.shopId,
				});
				params.onSuccess?.(returnRequest);
			},
			onError: (error) => {
				params.onError?.(error as Error);
			},
			mapVariables: (body: { shopId: string; returnRequestId: string }) => ({
				params: {
					path: { shopId: body.shopId, returnRequestId: body.returnRequestId },
				},
			}),
		},
	);
}
